export default element => {
  return element?.scrollHeight > element?.clientHeight;
};
